import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useEffect, useState } from 'react';
import SearchTab from '../components/searchTab/SearchTab';
import Menu from '../components/menu/Menu';
import ScrollToTopButton from '../components/ScrollToTopButton';
import { Outlet, Route, Routes } from 'react-router-dom';
import Quant1 from './Quant1/Quant1';
import Footer from '../components/footer/Footer';
import Quant2 from './Quant2/Quant2';
import Quant3 from './Quant3/Quant3';

export const QuantOutlet1 = () => (
  <Inner>
    <Quant1 />
  </Inner>
);

export const QuantOutlet2 = () => (
  <>
    <Quant2 />
    <Quant3 />
  </>
);

const Quent = () => {
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  return (
    <Container>
      <ScrollToTopButton />
      <PageTop
        text={'퀀트 분석 기반 테마 추천(宙)'}
        setOpenMenu={setOpenMenu}
      />
      <Content>
        <Outlet />
      </Content>
      <Footer />
      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};

export default Quent;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;

const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding: 40px 0 140px; */
  overflow-x: hidden;
`;
